var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-success"},[_c('h2',[_vm._v("Richiesta invitata con successo, "),_c('router-link',{attrs:{"to":{ name: 'landing' }}},[_vm._v("torna al sito")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }